import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Process } from "@bpm/models";
import { Status } from "@common/models";
import { environment } from "environments/environment";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class ProcessService {
  //EndPoint para controlador de este objeto en backend
  private processApiEnpoint = `${environment.bpmApiUrl}/api/processes`;

  constructor(private _http: HttpClient) {}

  //Obtiene todos los procesos
  getAllProcesses() {
    return this._http.get<Process[]>(this.processApiEnpoint);
  }

  //Obtiene el proceso por su Id
  getProcessById(processId: Number) {
    return this._http.get<Process>(`${this.processApiEnpoint}/${processId}`);
  }

  //Crea un nuevo proceso
  createNewProcess(process: Process) {
    process.status = new Status();
    process.status.code = "ACT";

    return this._http.post<{ message: String; process: Process }>(
      `${this.processApiEnpoint}`,
      process
    );
  }

  //Actualiza el proceso recibido
  updateProcess(process: Process) {
    return this._http.put<{ message: String; process: Process }>(
      `${this.processApiEnpoint}/${process.id}`,
      process
    ).pipe(
      map((response: any) => response.process as Process),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  //Cambia el status del proceso
  changeProcessStatus(processId: Number, statusCode: String) {
    return this._http.put<{ process: Process; message: String }>(
      `${this.processApiEnpoint}/${processId}/${statusCode}`,
      null
    );
  }

  //Función que compara 2 procesos para verificar si son iguales
  //se utiliza para comprobar si se necesita actualizar en el backend
  checkIfEqual(process1: Process, process2: Process) {
    if(process1.name !== process2.name) return false;
    if(process1.description !== process2.description) return false;
    if(process1.parent && !process2.parent) return false;
    if(!process1.parent && process2.parent) return false;
    if (process1.parent && process2.parent) {
      if(process1.parent.id !== process2.parent.id) return false;
    }
    return true;
  }
}
